import {products} from './feature.products.svelte.js';
import {booking} from '../booking/feature.booking.svelte.js';
import {page_json, progress} from '../progress/feature.progress.svelte.js';
import * as products_update from './products.scenarios.update.svelte.js';
import * as money_util from '../../utils/MoneyUtil.js';
import * as debug_actions from "../debug/actions_debug.svelte.js";
import * as progress_select from "../progress/progress.scenarios.select.svelte.js";
import DateTimeUtil from "../../utils/DateTimeUtil.js";

export function apiCallTreatmentsSuccess(html)
{
  debug_actions.debugAddLogFlow('products', 'apiCallTreatmentsSuccess', {html});
  progress.bIsFetchingTreatments = false;
  //InputUtil.updateProductsStateWithExternalTreatmentsInput(html);
}

export function apiCallRequestEntryPriceForDate(iBuyableID)
{
  // debug_actions.debugAddLogFlow('products', 'apiCallRequestEntryPriceForDate', {iBuyableID});
  // products_update.scenarioUpdateProductPriceForTodayWithoutRemoteCheck(iBuyableID);
}

export function updateProductPriceForDay(oData)
{
  // console.log('updateProductPriceForDay', oData);
  debug_actions.debugAddLogFlow('products', 'updateProductPriceForDay', {oData});
  const {iPrice, iBuyableID, sStartDate} = oData;
  const sCurrentArrivalDate = booking.sArrivalDate;

  if ( sStartDate === sCurrentArrivalDate )
  {
    if ( iPrice && iBuyableID )
    {
      products_update.scenarioUpdateProductPriceByID(
        iBuyableID,
        iPrice
      );
    }
  }
}

export function importFromOfAjaxCall(html)
{
  debug_actions.debugAddLogFlow('products', 'importFromOfAjaxCall');
  const htmlTreatments = '<div>' + html + '</div>'; // jquery heeft container nodig
  const aListsRefs = []; // een array met setjes

  jQuery(htmlTreatments).find(".subcat").each((index, elementSubcat) => {
    const aItems = [];

    jQuery(elementSubcat).find('.product').each((index, elementProduct) => {

      let htmlContent = '';
      const elContent = jQuery(elementProduct).find('.product__reservation-content'); // lange tekst
      if ( elContent ) htmlContent = elContent.html();

      let oImage = false;
      const elTeaserImage = jQuery(elementProduct).find('.product__teaserimg img');
      if ( elTeaserImage ) oImage = elTeaserImage.attr('src');
      const bIsDebugModeEnabled = progress_select.isDebugModeEnabled();
      if ( typeof oImage === 'undefined' || oImage === false && bIsDebugModeEnabled === true )
      {
        // Fallback afbeelding
        oImage = progress.sImageURLProduct;
      }

      let bIsAvailable = false;
      let sIsAvailable = jQuery(elementProduct).attr('data-availability');

      if ( sIsAvailable === "available" )
      {
        bIsAvailable = true;
      }

      let bIsPreselected = false;
      let sIsPreselected = jQuery(elementProduct).attr('data-preselected');

      if ( sIsPreselected === true || sIsPreselected === "true" )
      {
        bIsPreselected = true;
      }

      let bIsTreatment = false;
      let sIsTreatment = jQuery(elementProduct).attr('data-is-treatment');

      if ( sIsTreatment === true || sIsTreatment === "true" )
      {
        bIsTreatment = true;
      }

      let oProductConfig = {
        iID: parseInt(jQuery(elementProduct).attr('data-id')),
        sTitle: jQuery(elementProduct).find('.product__title').text(),
        iPrice: money_util.stringToCents(jQuery(elementProduct).attr('data-price')),
        sPrice: jQuery(elementProduct).attr('data-price'),
        sPriceString: jQuery(elementProduct).attr('data-price-string'),
        bIsPreselected: bIsPreselected, // is in de categorie al door PHP bovenaan gezet.. dit is nog voor weergave zoals het toevoegen van een class voor styling
        bIsAvailable: bIsAvailable,
        bIsTreatment: bIsTreatment,
        sDateUsed: DateTimeUtil.convertYYYYdashMMdashDDToDDdashMMdashYYYY(jQuery(elementProduct).attr('data-date')),
        htmlSummary: jQuery(elementProduct).find('.product__summary').html(),
        htmlContent: htmlContent,
        sImage: oImage
      };

      aItems.push(oProductConfig);
    });


    let bIsPreselectedCat = false;
    let sIsPreselectedCat = jQuery(elementSubcat).attr('data-preselected');

    if ( sIsPreselectedCat === true || sIsPreselectedCat === "true" )
    {
      bIsPreselectedCat = true;
    }

    const oSubcatData = {
      sID: jQuery(elementSubcat).attr('data-id'),
      sTitle: jQuery(elementSubcat).find('.subcat__title').text(),
      lItems: aItems,
      bIsPreselected: bIsPreselectedCat
    };
// console.log('floep 2', oSubcatData);
    aListsRefs.push(oSubcatData);
  });

  products.lAvailableTreatments = aListsRefs;

  // in deze html zit mogelijk ook informatie over beschikbare restaurant tijdslots
  const aRestaurantSlots = []; // een array met setjes
  jQuery(htmlTreatments).find(".js-restaurant-timeslot").each((index, elementRestaurantTimeSlot) => {
    const oTimeSlotData = {
      iTimeStart: parseInt(jQuery(elementRestaurantTimeSlot).attr('data-start')),
      iTimeEnd: parseInt(jQuery(elementRestaurantTimeSlot).attr('data-end'))
    }

    aRestaurantSlots.push(oTimeSlotData);
  });

  products.lRestaurantSlots = aRestaurantSlots;
}


export function importFromPageConfigAjaxCall()
{
  // De aanbevolen producten
  if ( typeof page_json.data.jsonHmkRecProducts !== 'undefined' )
  {
    products.aRecommendedProductIDs = page_json.data.jsonHmkRecProducts;
  }

  // De productcatalogus
  let aStateItems = products.lItems;

  if ( typeof page_json.data.jsonHmkCatalogueProducts === 'undefined' )
  {
    //DebugUtil.log('jsonHmkCatalogueProducts undefined', DebugUtil.DEBUG_CAT_ERRORS_GENERAL);
    //window.console.log('jsonHmkCatalogueProducts undefined', DebugUtil.DEBUG_CAT_ERRORS_GENERAL);
  }
  else
  {
    const oInput = page_json.data.jsonHmkCatalogueProducts;

    //window.console.log('jsonHmkCatalogueProducts verwerken!', DebugUtil.DEBUG_CAT_ERRORS_GENERAL, page_json.data.jsonHmkCatalogueProducts);

    if ( oInput !== false )
    {
      let oProduct, iProductID;
      oInput.forEach((oValFromJSON, sKeyFromJson) => {
        if ( typeof oValFromJSON.ID !== 'undefined' )
        {
          oProduct = {};
          iProductID = parseInt(oValFromJSON.ID);

          // DefaultTime: "10:00"
          // ID: "47"
          // PersMax: "1"
          // PersMin: "1"
          // Price: "0.00"
          // Title: "Entree arrangementen"
          // Together: "0"
          // IsProductWithoutSauna: "0"
          // eventueel: IsEntry= 1

          const idx = aStateItems.findIndex((oAlreadyAddedProduct) => oAlreadyAddedProduct.iID === iProductID);

          // alleen product toevoegen als we die nog niet hebben (ook ivm onbedoeld meerdere keren parsen)
          if ( idx === -1 )
          {
            oProduct.iID = iProductID;

            if ( typeof oValFromJSON.Ti !== 'undefined' ) oProduct.sTitle = oValFromJSON.Ti;
            if ( typeof oValFromJSON.Pr !== 'undefined' ) oProduct.iPrice = money_util.stringToCents(oValFromJSON.Pr);

            // console.log(
            //   'debugprod',
            //   parseInt(oValFromJSON.ID),
            //   oValFromJSON.Pr,
            //   money_util.stringToCents(oValFromJSON.Pr)
            // );

            oProduct.bIsEntry = false;
            if ( typeof oValFromJSON.Ent !== 'undefined' && oValFromJSON.Ent === "1" || oValFromJSON.Ent === 1 ) oProduct.bIsEntry = true;

            oProduct.bIsProductWithoutSauna = false;
            if ( typeof oValFromJSON.NoSau !== 'undefined' && oValFromJSON.NoSau === "1" || oValFromJSON.NoSau === 1 ) oProduct.bIsProductWithoutSauna = true;

            oProduct.bIsTreatment = false;
            if ( typeof oValFromJSON.IsTr !== 'undefined' && oValFromJSON.IsTr === "1" || oValFromJSON.IsTr === 1 ) oProduct.bIsTreatment = true;
          }

          aStateItems.push(oProduct);
        }
      });
    }
  }

  products.lItems = aStateItems;
}
